import { FooterLink, FooterLinkFields, FooterSectionFields } from '../../../../../types/types';
import { ActionSectionProps } from '../types/actionSection.types';

export class ActionSectionModel {
  private readonly fields?: FooterSectionFields;

  constructor(props: ActionSectionProps) {
    this.fields = props.field || null;
  }

  get dealerLink(): FooterLinkFields | undefined {
    const find = (list: FooterLink[] | undefined): FooterLink | undefined =>
      list?.find((item) => item?.fields?.type?.fields?.Key?.value === 'dealerLinkType');
    return find(this.fields?.footerLinks)?.fields;
  }

  get marketSelector(): FooterLinkFields | undefined {
    const marketSelectorContainer = this.fields?.footerLinks?.find(
      (link: FooterLink) => link?.fields?.type?.fields?.Key?.value === 'MarketSelectorType'
    );
    if (marketSelectorContainer) {
      return marketSelectorContainer?.fields?.list?.[1]?.fields;
    }
    return undefined;
  }

  get languageSelector(): FooterLinkFields | undefined {
    // eslint-disable-line
    const marketSelectorContainer = this.fields?.footerLinks?.find(
      (link) => link?.fields?.type?.fields?.Key?.value === 'MarketSelectorType'
    );
    if (marketSelectorContainer) {
      return marketSelectorContainer?.fields?.list?.[0]?.fields;
    }
    return undefined;
  }
}
